"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonacoEditor = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var util_1 = require("../util");
var form_1 = require("../form");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var MonacoDiffEditor_1 = require("./MonacoDiffEditor");
var use_isomorphic_layout_effect_1 = require("../_util/use-isomorphic-layout-effect");
exports.MonacoEditor = forward_ref_with_statics_1.forwardRefWithStatics(function MonacoEditor(_a, ref) {
    var monaco = _a.monaco, _b = _a.options, options = _b === void 0 ? {} : _b, _c = _a.override, override = _c === void 0 ? {} : _c, language = _a.language, className = _a.className, style = _a.style, width = _a.width, height = _a.height, props = tslib_1.__rest(_a, ["monaco", "options", "override", "language", "className", "style", "width", "height"]);
    var classPrefix = util_1.useConfig().classPrefix;
    var _d = form_1.useDefaultValue(props, ""), value = _d.value, onChange = _d.onChange;
    var containerRef = react_1.useRef(null);
    var editorRef = react_1.useRef(null);
    var changeEventRef = react_1.useRef(null);
    // https://github.com/react-monaco-editor/react-monaco-editor/blob/master/src/editor.js
    var preventTriggerChangeEvent = react_1.useRef(false);
    react_1.useEffect(function () {
        if (editorRef.current) {
            editorRef.current.layout();
        }
    }, [width, height]);
    react_1.useEffect(function () {
        if (editorRef.current) {
            var model = editorRef.current.getModel();
            monaco.editor.setModelLanguage(model, language);
        }
    }, [language, monaco]);
    react_1.useEffect(function () {
        if (editorRef.current) {
            var editor = editorRef.current;
            var model = editor.getModel();
            if (value != null && value !== model.getValue()) {
                preventTriggerChangeEvent.current = true;
                editor.pushUndoStop();
                model.pushEditOperations([], [
                    {
                        range: model.getFullModelRange(),
                        text: value,
                    },
                ], undefined);
                editor.pushUndoStop();
                preventTriggerChangeEvent.current = false;
            }
        }
    }, [value, monaco]);
    use_isomorphic_layout_effect_1.useIsomorphicLayoutEffect(function () {
        var editor = monaco.editor.create(containerRef.current, tslib_1.__assign(tslib_1.__assign({}, options), { value: value,
            language: language }), override);
        editorRef.current = editor;
        changeEventRef.current = editor.onDidChangeModelContent(function (event) {
            if (!preventTriggerChangeEvent.current) {
                onChange(editor.getValue(), { event: event });
            }
        });
        return function () {
            editorRef.current.dispose();
            var model = editorRef.current.getModel();
            if (model) {
                model.dispose();
            }
            if (changeEventRef.current) {
                changeEventRef.current.dispose();
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    react_1.useImperativeHandle(ref, function () { return ({
        editor: editorRef.current,
    }); });
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-monaco-editor-container", className), style: tslib_1.__assign(tslib_1.__assign({}, (style || {})), { height: height || "100%", width: width || "100%" }), ref: containerRef }));
}, {
    DiffEditor: MonacoDiffEditor_1.MonacoDiffEditor,
});
exports.MonacoEditor.displayName = "MonacoEditor";
//# sourceMappingURL=MonacoEditor.js.map